<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    min
  >
    <v-card>
      <v-card-title
        class="pb-0"
        flex
      >
        <v-toolbar-title>{{ fullName }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-tabs
        ref="tabs"
        v-model="tabActive"
        class="mx-3"
        flex
        slider-color="#f4b944"
      >
        <v-tab style="width: 0" />

        <v-tab
          v-if="isTrainer"
          ripple
        >
          Personal Information
        </v-tab>

        <v-tab
          v-if="isTrainer"
          ripple
        >
          Skills
        </v-tab>

        <v-tab ripple>
          Update your password
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tabActive"
        class="px-3"
      >
        <v-tab-item />

        <v-tab-item
          v-if="isTrainer"
          class="pt-3"
        >
          <v-card-text class="mx-0 px-0">
            <v-form
              ref="informationForm"
              layout="column"
            >
              <v-text-field
                v-model="userInfoFormData.firstname"
                label="First name *"
                :rules="[ v => !!v || 'This field is required' ]"
                outline
                class="full-width"
              />
              <v-text-field
                v-model="userInfoFormData.lastname"
                label="Last name *"
                :rules="[ v => !!v || 'This field is required' ]"
                outline
                class="full-width"
              />
              <v-text-field
                v-model="userInfoFormData.email"
                label="E-mail"
                outline
                class="full-width"
                type="email"
              />
              <v-text-field
                v-model="userInfoFormData.phone"
                label="Phone number"
                outline
                class="full-width"
              />
              <v-checkbox
                v-model="userInfoFormData.is_notifs_enabled"
                label="Receive notifications from POP"
                :true-value="1"
                :false-value="0"
                class="full-width"
              />
              <v-checkbox
                v-if="userInfoFormData.is_notifs_enabled"
                v-model="userInfoFormData.daily_recap"
                label="Receive mails in daily recap mode (if no, each notification will be sent individually)"
                :true-value="1"
                :false-value="0"
                class="full-width"
              />
              <div class="title font-weight-light mb-3">
                Data for indemnities
              </div>
              <v-text-field
                v-model="userInfoFormData.matricule"
                outline
                label="N° de matricule"
                :rules="[v => !!v || 'This field is required']"
              />
              <v-select
                v-model="userInfoFormData.country_id"
                v-focus
                outline
                clearable
                label="Country of residence"
                :rules="[v => !!v || 'This field is required' ]"
                :items="countries"
                item-value="iso"
                item-text="name"
              />
              <div v-if="userInfoFormData.country_id == 'lu'">
                <div layout="row">
                  <v-menu
                    v-model="menuVisible"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :offset-y="true"
                    max-height="300"
                    open-on-focus
                    transition="fade-transition"
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        ref="searchField"
                        v-model="search"
                        label="Rechercher une rue luxembourgeoise"
                        :loading="loading"
                        clearable
                        hide-details
                        :disabled="ignore_lux_cities"
                        @input="onSearchInput"
                        @focus="menuVisible = true"
                        v-on="on"
                      />
                    </template>
                    <v-card flat>
                      <v-list v-if="streets.length > 0">
                        <v-list-tile
                          v-for="street in streets"
                          :key="street.id"
                          @click="onStreetSelected(street)"
                        >
                          <v-list-tile-content>
                            <v-list-tile-title>{{ street.name }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>

                      <v-list v-else>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Aucun résultat</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-menu>
                </div>
                <div
                  layout="row"
                  style="margin-bottom: 20px"
                >
                  <v-checkbox
                    v-model="ignore_lux_cities"
                    label="Je n'ai pas trouvé l'adresse"
                    hide-details
                    @change="onChangeIgnoreLuxCities"
                  />
                </div>
              </div>
              <div class="one-row">
                <v-text-field
                  v-model="userInfoFormData.streetnumber"
                  outline
                  label="Street number"
                  class=" w200 mr-1"
                  :rules="[v => !!v || 'This field is required']"
                />
                <v-text-field
                  v-model="userInfoFormData.streetname"
                  outline
                  label="Street name"
                  class=" grow"
                  :rules="[v => !!v || 'This field is required']"
                  :readonly="!ignore_lux_cities"
                />
              </div>
              <div class="one-row">
                <v-text-field
                  v-model="userInfoFormData.postalcode"
                  outline
                  label="Postal code"
                  class="w200 mr-1"
                  :rules="[v => !!v || 'This field is required']"
                  :readonly="!ignore_lux_cities"
                />
                <v-text-field
                  v-model="userInfoFormData.city"
                  outline
                  label="City"
                  class="grow"
                  :rules="[v => !!v || 'This field is required']"
                  :readonly="!ignore_lux_cities"
                />
              </div>
              <div class="one-row">
                <v-text-field
                  v-model="userInfoFormData.iban"
                  outline
                  label="IBAN"
                  class="grow mr-1"
                  :rules="[v => !!v || 'This field is required']"
                />
                <v-text-field
                  v-model="userInfoFormData.bic"
                  outline
                  label="BIC"
                  class="w200"
                  :rules="[v => !!v || 'This field is required']"
                />
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <span flex />
            <v-btn
              depressed
              color="primary"
              @click="saveInfo"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-tab-item>

        <v-tab-item
          v-if="isTrainer"
          class="pb-4"
        >
          <v-data-table
            :headers="[
              { text: 'Status', value: 'is_enabled', sortable: false, width: 75 },
              { text: 'Concept', value: 'topic.name' },
              { text: 'Role', value: 'role' },
              { text: 'Former', value: 'is_former' },
              { text: 'Seasons', value: 'seasons', sortable: false },
            ]"
            :items="skills"
            :pagination.sync="pagination"
          >
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>
                <v-icon
                  :color="getSkillColor(item)"
                  :title="getSkillTitle(item)"
                >
                  mdi-circle-outline
                </v-icon>
              </td>
              <td>{{ item.topic.name }}</td>
              <td>{{ getSkillRoleLabel(item.role) }}</td>
              <td>
                <v-icon
                  v-if="item.is_former"
                  color="success"
                >
                  mdi mdi-check
                </v-icon>
                <v-icon
                  v-else
                  color="error"
                >
                  mdi mdi-close
                </v-icon>
              </td>
              <td>
                <div
                  v-for="s in item.seasons"
                  :key="item.id + s.id"
                  layout="row"
                >
                  {{ s.team.name + ' (' + formatDate(s.start) + ' - ' + formatDate(s.end) + ')' }}
                </div>
              </td>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item class="pt-3">
          <v-card-text class="mx-0 px-0">
            <v-form
              ref="passwordForm"
              layout="column"
              layout-align="center center"
            >
              <v-text-field
                v-model="userPasswordFormData.current_password"
                label="Current password *"
                type="password"
                :rules="[v => !!v || 'This field is required']"
                outline
                class="full-width"
              />

              <v-text-field
                v-model="userPasswordFormData.new_password"
                label="New password *"
                type="password"
                :rules="[v => !!v || 'This field is required']"
                outline
                class="full-width"
              />

              <v-text-field
                v-model="userPasswordFormData.conf_password"
                label="Confirm the password *"
                type="password"
                :rules="confRules"
                outline
                class="full-width"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <span flex />
            <v-btn
              depressed
              color="primary"
              @click="savePassword"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import Auth from "@/plugins/auth";
import Consts from "@/consts";
import Params from '@/api/params'
import GroupsMixin from '@/mixins/groups'
import DateMixin from '@/mixins/date'
import Users from "@/api/users"
import moment from 'moment'

export default {
  mixins: [GroupsMixin, DateMixin],
  data () {
    return {
      dialog: false,
      tabActive: 0,
      skills: [],
      pagination: {rowsPerPage: 5},
      userInfoFormData: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        is_notifs_enabled: 1,
        daily_recap: 1,
        matricule: '',
        country_id: null,
        city_id: null,
        street_id: null,
        streetnumber: '',
        streetname: '',
        postalcode: '',
        city: '',
        iban: '',
        bic: ''
      },
      streets: [],
      menuVisible: false,
      search: '',
      loading: false,
      ignore_lux_cities: false,
      searchTimeout: null,
      userPasswordFormData: {
        current_password: "",
        new_password: "",
        conf_password: "",
      },
      countries: []
    };
  },
  computed: {
    fullName () {
      return Auth.user.firstname + " " + Auth.user.lastname;
    },
    confRules () {
      return [
        v => !!v || "This field is required",
        v =>
          (v && v === this.userPasswordFormData.new_password) ||
          "Confirmation does not match the input"
      ];
    },
    isTrainer () {
      return Auth.user.role == Consts.TRAINER
    }
  },
  async mounted() {
    const {data} = await Params.getList("countries", {sortBy: "name"})
    this.countries = data;
  },
  methods: {
    open () {
      this.fetchSkills()
      this.dialog = true;
      this.$nextTick(() => {
        this.tabActive = 1
        this.userInfoFormData = {
          firstname: Auth.user.firstname,
          lastname: Auth.user.lastname,
          email: Auth.user.email,
          phone: Auth.user.phone,
          is_notifs_enabled: Auth.user.is_notifs_enabled,
          daily_recap: Auth.user.daily_recap,
          matricule: Auth.user.matricule,
          country_id: Auth.user.country_id,
          city_id: Auth.user.city_id,
          street_id: Auth.user.street_id,
          streetnumber: Auth.user.streetnumber,
          streetname: Auth.user.streetname,
          postalcode: Auth.user.postalcode,
          city: Auth.user.city,
          iban: Auth.user.iban,
          bic: Auth.user.bic
        }

        this.ignore_lux_cities = this.userInfoFormData.country_id != 'lu' || ! this.userInfoFormData.street_id

        this.userPasswordFormData = {
          current_password: "",
          new_password: "",
          conf_password: ""
        }
        this.$refs.passwordForm.resetValidation()
      })
    },
    fetchSkills () {
      Params.getList(`users/${Auth.user.id}/skills`).then(res => {
        this.skills = res.data;
      })
    },
    getSkillColor(s){
      if(!s.is_enabled){
        return 'error'
      }
      let found = false
      if(s.seasons && s.seasons.length){
        s.seasons.forEach(us => {
          if(moment(us.end).isSameOrAfter(moment()) && moment(us.start).isSameOrBefore(moment())){
            found = true
          }
        })
      }
      if(found){
        return 'success'
      }

      return 'warning'
    },
    getSkillTitle(s){
      if(!s.is_enabled){
        return 'Disabled'
      }
      let found = false
      if(s.seasons && s.seasons.length){
        s.seasons.forEach(us => {
          if(moment(us.end).isSameOrAfter(moment()) && moment(us.start).isSameOrBefore(moment())){
            found = true
          }
        })
      }
      if(found){
        return 'Enabled'
      }

      return 'Enabled but no active season'
    },
    getNextSeasons(s){
      const arr = []

      if(s.seasons && s.seasons.length){
        s.seasons.forEach(us => {
          if(moment(us.end).isSameOrAfter(moment())){
            arr.push(us)
          }
        })
      }

      return arr
    },
    savePassword () {
      if (!this.$refs.passwordForm.validate()) {
        this.$snotify.error("Please verify the required fields");
        return;
      }

      Users.updatePassword(this.userPasswordFormData).then(() => {
        this.$snotify.success("Password updated");
        this.dialog = false;
      });
    },
    saveInfo () {
      if (!this.$refs.informationForm.validate()) {
        this.$snotify.error("Please verify the required fields");
        return;
      }
      Users.updatePersonalInfo(this.userInfoFormData).then(() => {
        this.$nextTick(() => {
          Auth.user = Object.assign(Auth.user, this.userInfoFormData)
          localStorage.setItem("user", JSON.stringify(Auth.user))
        })
        this.$snotify.success(`Your information has been updated`)
      })
    },
    // ----------------- Pour la gestion de l'adresse -----------------
    onChangeCountry() {
      if(this.userInfoFormData.country_id == 'lu') {
        this.ignore_lux_cities = false
      }
      else {
        this.ignore_lux_cities = true
        this.userInfoFormData.city_id = null
        this.userInfoFormData.street_id = null
      }
    },
    onSearchInput(val) {
      if (!val || val.length < 3) {
        this.streets = [];
        this.menuVisible = false;
        return;
      }

      this.loading = true;
      this.menuVisible = true
      clearTimeout(this.searchTimeout) //debounce

      this.searchTimeout = setTimeout(() => {
        this.onSearchStreet(val)
      }, 500)
    },
    async onSearchStreet(search) {
      this.streets.splice(0)
      const {data} = await Params.getList("streets", {search})
      this.streets.push(...data)
      this.loading = false
    },
    onStreetSelected(street) {
      this.userInfoFormData.street_id = street.id ?? null
      if(this.userInfoFormData.street_id) {
        this.userInfoFormData.city_id = street.city_id
        this.userInfoFormData.streetname = street.streetname
        this.userInfoFormData.postalcode = street.postalcode
        this.userInfoFormData.city = street.cityname
      }
      else {
        this.userInfoFormData.city_id = null
        this.userInfoFormData.streetname = ""
        this.userInfoFormData.postalcode = ""
        this.userInfoFormData.city = null
      }

      this.search = street.name;
      this.menuVisible = false;
    },
    onChangeIgnoreLuxCities() {
      this.userInfoFormData.street_id = null
      this.userInfoFormData.city_id = null
    }
  },
};
</script>
<style lang="sass">
  .v-menu__content.menuable__content__active
    z-index: 300 !important
</style>
<style scoped lang="sass">


  .one-row
    display: flex
    flex-direction: row
    flex-wrap: wrap

    .v-input
      flex: unset

    .grow
      flex-grow: 1

    .w350
      width: 350px
    .w200
      width: 200px

</style>
